import { AxiosInstance } from 'axios';
import { createContext } from 'react';

export const ApiClientContext = createContext<AxiosInstance | undefined>(undefined);
